module.exports = __webpack_public_path__ + "static/media/star.363a789a.svg";